<template>
  <div>
    <h1>Alex Homepage</h1>

    <p>
      <a
        class="btn btn-primary"
        data-bs-toggle="collapse"
        href="#collapseExample"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        Link with href
      </a>
      <button
        class="btn btn-primary"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseExample"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        Button with data-bs-target
      </button>
    </p>
    <div class="collapse" id="collapseExample">
      <ol class="list-group">
        <li
          class="list-group-item d-flex justify-content-between align-items-start"
        >
          <div class="ms-2 me-auto">
            <div class="fw-bold">Subheading</div>
            Cras justo odio
          </div>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-start"
        >
          <div class="ms-2 me-auto">
            <div class="fw-bold">Subheading</div>
            Cras justo odio
          </div>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-start"
        >
          <div class="ms-2 me-auto">
            <div class="fw-bold">Subheading</div>
            Cras justo odio
          </div>
        </li>
      </ol>
    </div>
    <!-- ADD CONTENT IN THIS AREA - MUST BE BETWEEN DIV TAGS -->
    <section class="container-fluid bg-primary">
      <div class="row">
        <div class="col-sm-12 col-md-6 my-auto text-white p-5">
          <h2>Alex Homepage</h2>
          <p>
            Fusce lobortis nulla odio, ac eleifend metus laoreet sed. Cras
            gravida ullamcorper venenatis.
          </p>
          <ul>
            <li>List Item 1</li>
            <li>List Item 2</li>
            <li>List Item 3</li>
            <li>List Item 4</li>
          </ul>
          <p>
            Fusce lobortis nulla odio, ac eleifend metus laoreet sed. Cras
            gravida ullamcorper venenatis.
          </p>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 bg-primary p-0">
          <div class="">
            <img
              src="https://source.unsplash.com/random/1200x1200"
              title=""
              alt=""
              class="img-fluid w-100"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AlexHomepage",
  route: {
    path: "/alex-homepage", // this is the url path
  },
};
</script>

<style lang="scss">
// add styles here supports scss
</style>
